import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BaseReactComponent, CustomTextControl, Form, FormElement, FormSubmitButton, FormValidator, SelectControl } from "../../utils/form";
import { Table, Image, Row, Col, Tabs, Tab, Button, Modal, Spinner } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import { getCustomerLoginDetailsApi, getDetaisCustomerApi, resetCustomerSpecsApi } from "./Api";
import { InformationModal } from "../common";
import closeIcon from '../../assets/images/greay-cancel-icon.svg';
import moment from "moment";
import editIcon from '../../assets/images/edit-icon.svg'
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ALT_THUMBNAIL, COBRAND, DOWNLOAD, MAX_LIMIT, NON_PREMIUM, NumberOfDays, PREMIUM, SUPER_ADMIN, TYPE_OPTION, durationObj } from "../../utils/Constant";
import { getAllUploadSectionApi, getCommonApi, patchAuthCommonApi, postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import { getAllContentTypeApi } from "../MasterCategory/Api";
import de from "date-fns/esm/locale/de/index.js";
import { withRouter } from "../../utils/hoc/withRouter";
class CustomerDetails extends BaseReactComponent {
  constructor(props) {
    super(props);
    const { params } = props.match;

    this.state = {
      params,
      detailsData: "",
      activeTab: '',
      subscriptionLoading: false
    };
    this.handleChildAction = this.handleChildAction.bind(this);
  }

  handleChildAction() {
    getDetaisCustomerApi("customer", this);
  }

  componentDidMount = () => {
    const { history } = this.props;
    getDetaisCustomerApi("customer", this);
    getAllUploadSectionApi(this);
    this.props.history({ search: 'tab=details' })
  }


  detailsTab = (data) => {
    return (
      <div className="view-details-content">
        <div className="user-details d-flex">
          <div className="eclipse">
            <Image src={data?.profilePicturePath} className="eclipse" />
          </div>
          <div className="name-details">
            <h3 className="inter-medium f-s-20">{data?.firstName || ""} {data?.lastName || ""} </h3>
            <h4 className="inter-medium grey-3 f-s-14">{data?.emailAddress}</h4>

          </div>

        </div>
        <h3 className="inter-regular f-s-14 grey-2">
          Details
        </h3>
        <div className="line2"></div>
        <Table className="custom-table">
          <Row>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Email</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.emailAddress || "xyz@gmail.com"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Phone no.</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.mobileNumber || "na"}</h3>
              </div>
            </Col>

            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">DOB</h4>
                <h3 className="inter-semibold f-s-14 ">{moment(data?.dateOfBirth).format("L") || ""}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Gender</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.gender}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Company Inceptin
                </h4>
                <h3 className="inter-semibold f-s-14 ">{moment(data?.companyInception).format("L") || ""}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Organization Name
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.companyName || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Organization Type
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.organizationType || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">ARN Number</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.arnNumber || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">City</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.city || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">State</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.state || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Pincode</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.pincode || "Na"}</h3>
              </div>
            </Col>

            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Unverified Email Address</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.unverifiedEmailAddress || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Unverified Mobile Number</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.unverifiedMobileNumber || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Euin Number</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.euinNumber || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Gst Number</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.gstNumber || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Organization Logo</h4>
                <Image src={data?.organizationLogoPath} className="detail-page-image" />
              </div>
            </Col>
          </Row>
        </Table>
      </div>
    )
  }
  detailsTab1 = (data) => {

    return (
      <div className="view-details-content">
        <div className="user-details d-flex">
          <div className="eclipse">
            <Image src={data?.event?.thumbnailPath || closeIcon} className="eclipse" />
          </div>
          <div className="name-details">
            <h3 className="inter-medium f-s-20">{data?.event?.name || "Na"} </h3>

          </div>

        </div>
        <h3 className="inter-regular f-s-14 grey-2">
          Details
        </h3>
        <div className="line2"></div>
        <Table className="custom-table">
          <Row>

            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Event date</h4>
                <h3 className="inter-semibold f-s-14 ">{moment(data?.event?.date).format("L") || ""}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">City</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.city || "Na"}</h3>
              </div>
            </Col>

            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Event format
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.eventFormat || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Venue name
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.venueName || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Online link</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.onlineLink || "na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Event format</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.eventFormat || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Total seats</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.totalSeats || "Na"}</h3>
              </div>
            </Col>


            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Event type</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.event?.eventType || "na"}</h3>
              </div>
            </Col>

            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">BannerPath logo</h4>
                <Image src={data?.event?.bannerPath} className="detail-page-image" />
              </div>
            </Col>
          </Row>
        </Table>
      </div>
    )
  }



  returnDate(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toISOString().split('T')[0];
    return formattedDate;
  }

  render() {
    const { data, activeTab, params } = this.state;

    return (
      <section className="user-section">
        <div className="view-details-wrapper">
          <ComponentHeader
            title={`Customer Details`}
            isBackArrow={true}
            breadcrumb={[["Customers", "/customers"], ["Customer Details", ""]]}
            isReturn={"/customers"}
          />
          <div className="view-details">
            <Tabs
              defaultActiveKey={'Details'}
              onSelect={(d) => { this.setState({ activeTab: d }); this.props.history({ search: 'tab=' + d }) }}
              className="inter-regular f-s-16 lh-22 user-details-tabs"
              id=""
            >
              <Tab eventKey={'Details'} title={'Details'}>
                {this.detailsTab(data)}
              </Tab>
              <Tab eventKey={'Activity'} title={'Content Activity'}>
                <MyActivity data={data?.userActivities} />

              </Tab>
              <Tab eventKey={'LoginActivity'} title={'Login Activity'}>
                <LoginActivity userId={data?.id} />
              </Tab>
              <Tab eventKey={'Subscription'} title={'Subscription'}>
                <CustomerSubscription userData={data} history={this.props.history} data={data?.userSubscriptions} handleAction={this.handleChildAction} id={params.adsID} userId={data?.id} subscriptionLoading={this.state.subscriptionLoading} />
              </Tab>
              <Tab eventKey={'userEvents'} title={'User Events'}>

                <MyEvents data={data?.userEvents} />
              </Tab>

            </Tabs>

          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({ usersState: state.UsersState });
const mapDispatchToProps = {
  // getPosts: fetchPosts
};
CustomerDetails.propTypes = {
  // getPosts: PropTypes.func
  location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerDetails));


function MyActivity({ data }) {

  const [activityType, setActivityType] = useState('Downloaded');
  const [activityData, setActivityData] = useState([])
  const uniqueTypes = ['Cobrand', 'Downloaded', 'Liked', 'Shared']; // List of all unique types

  const TabsNames = [{ name: 'Downloads', type: "Downloaded" }, { name: "Co-Brands", type: "Cobrand" }, { name: "Likes", type: "Liked" }, { name: "Shares", type: "Shared" }, { name: "Recent Search", type: "Search" },]

  return (
    <div className="activity-tabs-section">
      <Tabs
        defaultActiveKey={'Cobrand'}
        onSelect={(data) => { setActivityType(data); console.log(data) }}
        className="inter-regular f-s-16 lh-22 user-details-tabs bg-ECE"
        id=""
      >

        {uniqueTypes.map((type) => {
          const filteredData = data?.filter(item => item.type === type);

          return (
            <Tab eventKey={type} title={type} key={type}>
              {filteredData?.length > 0 ? (
                <div className="commom-table-wrapper">
                  <CustomTable
                    data={filteredData || []}
                    columns={[
                      {
                        width: 300,
                        title: "Title",
                        dataIndex: "title",
                        className: "name",
                        isCell: true,
                        render: (text, rowData, dataKey) => {
                          return rowData?.title;
                        },
                      },

                      {
                        width: 300,
                        title: "Content Type",
                        dataIndex: "contentType",
                        className: "name",
                        isCell: true,
                        render: (text, rowData, dataKey) => {
                          return rowData?.contentType;
                        },
                      },
                      {
                        width: 300,
                        title: "Thumbnail Image",
                        dataIndex: "thumbnail",
                        className: "",
                        isCell: true,
                        render: (text, rowData, dataKey) => {
                          return rowData.thumbnail ? (
                            <Image
                              src={rowData.thumbnail}
                              className="table-img"
                              alt={ALT_THUMBNAIL}
                            />
                          ) : (
                            "NA"
                          );
                        },
                      },

                    ]}

                  />
                </div>
              ) : (
                <h1 className="inter-regular f-s-24 lh-32 text-center py-4 w-100">
                  No data...
                </h1>
              )}
            </Tab>
          );
        })}



      </Tabs>
    </div>
  )
}




const formatLoginDate = (value) => {
  if (!value) return "-";
  const ts = typeof value === "number" ? (value < 1e12 ? value * 1000 : value) : value;
  const m = moment(ts);
  return m.isValid() ? m.format("lll") : "-";
};

function LoginActivity({ userId }) {
  const [loginData, setLoginData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const fetchLoginDetails = async () => {
      setLoading(true);
      const res = await getCustomerLoginDetailsApi(userId);
      const payload = res?.data?.data;
      const list = Array.isArray(payload)
        ? payload
        : payload?.list || payload?.loginDetails || [];
      setLoginData(list);
      setLoading(false);
    };

    fetchLoginDetails();
  }, [userId]);

  if (loading) {
    return (
      <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-12">
        <Spinner classes={'black-border'} /> Loading...
      </div>
    );
  }

  if (!loginData?.length) {
    return (
      <h1 className="inter-regular f-s-24 lh-32 text-center py-4 w-100">
        No data...
      </h1>
    );
  }

  return (
    <div className="commom-table-wrapper">
      <CustomTable
        data={loginData}
        columns={[
          {
            width: 250,
            title: "Login Date",
            dataIndex: "createdAt",
            className: "name",
            isCell: true,
            render: (text, rowData) => formatLoginDate(rowData?.createdAt),
          },
        ]}
      />
    </div>
  );
}

class CustomerSubscription extends BaseReactComponent {
  constructor(props) {

    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      userData: this.props.userData,

      activeHistory: false,
      show: false,
      editShow: false,
      plan: '',
      offerLine: '',
      editDetails: {},
      resetInDays: "",
      billingFrequency: '',
      plansData: [],
      subPremiumPlan: [],
      subPremiumPlanVariation: [],
      contentTypeOptions: [],
      uploadSectionOptions: [],
      subscriptionDetails: [],
      userDetails: JSON.parse(localStorage.getItem('finAdmin')),
      isCustom: false,
      isLoading: false,
      isEditLoading: false,
      formRef: null,
      isTopUp: false,
      resetUsage: false,
      resetLoading: false,
      features: [
        { uuid: '', type: '', contentType: '', actionType: '', premium: '', limit: '', uploadSection: '', resetInDays: '' }
      ],
      editFeatures: [
        { uuid: '', type: '', contentType: '', actionType: '', premium: '', limit: '', uploadSection: '', resetInDays: '' }
      ]
    };
  }

  handleEdit = (d) => {
    const updatedSpecifications = d.specifications.map(spec => ({
      ...spec,
      contentType: spec.contentType ? spec.contentType.split(',') : [],
      uploadSection: spec.uploadSection ? spec.uploadSection.split(',') : [],
      actionType: spec.actionType ? spec.actionType.split(',') : [],
      premium: spec.contentCategory ? spec.contentCategory.split(',') : []
    }));

    this.setState({
      editDetails: d,
      editShow: true,
      editFeatures: updatedSpecifications,
      resetInDays: d?.subPremiumPlanVariation?.resetInDays,
      isTopUp: d?.isTopup
    });

  };

  componentDidMount = () => {
    const { history } = this.props;
    getAllUploadSectionApi(this);
    getAllContentTypeApi(this);
  }

  handleClick() {
    this.props.handleAction();
  }

  resetUsageHandle = async (id) => {
    if (this.state.resetLoading) return;
    this.setState({ resetLoading: true });
    const res = await resetCustomerSpecsApi(id);
    this.setState({ resetLoading: false, resetUsage: false });
    if (res?.status > 199 && res?.status < 250) {
      this.handleClick();
    }
  };

  onHide = () => {
    this.setState({ show: false });
    this.setState({
      plan: '',
      offerLine: '',
      resetInDays: "",
      billingFrequency: '',
      features: [
        { uuid: '', type: '', contentType: '', actionType: '', premium: '', limit: '', uploadSection: '', resetInDays: '' }
      ],
    })
  };
  onEditHide = () => {
    this.setState({ editShow: false });
  };

  onShow = async () => {
    this.setState({ show: true });
    const res = await getCommonApi(`premium-plan?pageSize=${MAX_LIMIT}`);
    this.setState({ plansData: res.data.data.list });
  };
  handleAddFeature = () => {
    this.setState((prevState) => ({
      features: [
        ...prevState.features,
        { uuid: '', type: '', contentType: '', actionType: '', premium: '', limit: '', uploadSection: '', resetInDays: '' }
      ]
    }));
  };

  handleAddEditFeature = () => {
    this.setState((prevState) => ({
      editFeatures: [
        ...prevState.editFeatures,
        { uuid: '', type: '', contentType: '', actionType: '', premium: '', limit: '', uploadSection: '', resetInDays: '' }
      ]
    }));
  };


  removeFeatures = (index) => {
    this.setState((prevState) => ({
      features: prevState.features.filter((_, i) => i !== index)
    }));
  };
  removeEditFeatures = (index) => {
    this.setState((prevState) => ({
      editFeatures: prevState.editFeatures.filter((_, i) => i !== index)
    }));
  };

  getAttachedDetails = (rowData) => {
    const { history } = this.props;
    history({ pathname: `/view-customer-details`, state: { "data": rowData } });
  }

  renderFeature = (ele, id) => {
    const { features, isTopUp, contentTypeOptions, uploadSectionOptions, expiryInDays, premiumPlans, resetInDaysOptions, postPlannerDurationInDays } = this.state;
    return (
      <>
        {
          id > 0 &&
          <><hr /><br /></>
        }
        <p className="variation-srno f-s-14">Features -{id + 1} </p>
        <div className="d-flex justify-content-between align-items-center">

          <Row key={id} className="w-100">

            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, `features.${id}.type`)}
                label="Type"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select Type",
                    options: TYPE_OPTION,
                    multiple: false,
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.features[id].type);


                      this.setState((prevState) => {
                        const updatedFeatures = [...prevState.features]; // Copy the array
                        updatedFeatures[id] = {
                          ...updatedFeatures[id], // Copy the object at index 'id'
                          uploadSection: "",
                          contentType: "",
                          actionType: "",
                          premium: "",
                          limit: "",
                          resetInDays: ""// Update the specific field
                        };
                        return { features: updatedFeatures }; // Set the new array as state
                      });

                    }
                  },
                }}
              />
            </Col>
            {features[id]?.type === TYPE_OPTION[1].value && <>
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.uploadSection`)}
                  label="Upload Section"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Upload section cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Upload Section",
                      options: uploadSectionOptions,
                      multiple: true,
                      searchable: true,
                      // disabled: (userAmcUuids()?.length > 0),
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id].uploadSection);

                      },
                    },
                  }}
                />
              </Col>
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.contentType`)}
                  label="Content Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Content Type",
                      options: contentTypeOptions,
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id].contentType);

                      },
                    },
                  }}
                />
              </Col>

              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.actionType`)}
                  label="Action Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Action Type",
                      options: [
                        { label: 'Download', value: DOWNLOAD },
                        { label: 'Co-Brand / Whitelabeling', value: COBRAND },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id].actionType);

                      },
                    },
                  }}
                />
              </Col>

            </>
            }
            {features[id]?.type === TYPE_OPTION[2].value &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.actionType`)}
                  label="Action Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Action Type",
                      options: [
                        { label: 'Download', value: DOWNLOAD },
                        { label: 'Co-Brand / Whitelabeling', value: COBRAND },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id].actionType);

                      },
                    },
                  }}
                />
              </Col>
            }
            {
              features[id]?.type !== TYPE_OPTION[2].value &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.premium`)}
                  label="Premium / Free"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Premium / Free",
                      options: [
                        { label: 'Premium', value: PREMIUM },
                        { label: 'Free', value: NON_PREMIUM },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id].premium);

                      },
                    },
                  }}
                />
              </Col>
            }
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, `features.${id}.limit`)}
                label="Limit"
                required
                validations={[
                  {
                    validate: FormValidator.isNum,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    // type: "",
                    placeholder: "Enter Limit",
                  },
                }}
              />
            </Col>
            {!isTopUp &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `features.${id}.resetInDays`)}
                  label="Replenishment In"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Replenishment In",
                      options: NumberOfDays?.filter(item => {
                        const answer = this?.state?.subPremiumPlanVariation?.subPremiumPlanVariation?.find(
                          (plan) => plan.uuid === this.state?.billingFrequency
                        )?.resetInDays;
                        return parseInt(answer) >= parseInt(item.value);
                      }),
                      multiple: false,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.features[id]?.resetInDays);
                        // const result = typeOptions.find(({ value }) => value === this.state.type);
                        // this.setState({ typeLabel: result.label, })


                      },
                    },
                  }}
                />
              </Col>
            }
          </Row>
          <div className="p-4">
            <Image src={closeIcon} className="remove-icon position-static" onClick={() => this.removeFeatures(id)} />
          </div>

        </div>

      </>
    );
  };
  renderEditFeature = (ele, id) => {

    const { features, isTopUp, contentTypeOptions, uploadSectionOptions, expiryInDays, premiumPlans, resetInDaysOptions, postPlannerDurationInDays, editFeatures } = this.state;
    return (
      <>
        {
          id > 0 &&
          <><hr /><br /></>
        }
        <p className="variation-srno f-s-14">Features -{id + 1} </p>
        <div className="d-flex justify-content-between align-items-center">

          <Row key={id} className="w-100">
            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, `editFeatures.${id}.type`)}
                label="Type"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select Type",
                    options: TYPE_OPTION,
                    multiple: false,
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.editFeatures[id]?.type);
                      this.setState((prevState) => {
                        const updatedFeatures = [...prevState.editFeatures]; // Copy the array
                        updatedFeatures[id] = {
                          ...updatedFeatures[id], // Copy the object at index 'id'
                          uploadSection: "",
                          contentType: "",
                          actionType: "",
                          premium: "",
                          limit: "",
                          resetInDays: ""// Update the specific field
                        };
                        return { editFeatures: updatedFeatures }; // Set the new array as state
                      });

                    },
                  },
                }}
              />
            </Col>
            {this.state.editFeatures[id]?.type === TYPE_OPTION[1]?.value && <>
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.uploadSection`)}
                  label="Upload Section"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Upload section cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Upload Section",
                      options: uploadSectionOptions,
                      multiple: true,
                      searchable: true,
                      // disabled: (userAmcUuids()?.length > 0),
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id].uploadSection);
                      },
                    },
                  }}
                />
              </Col>
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.contentType`)}
                  label="Content Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Content Type",
                      options: contentTypeOptions,
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id].contentType);

                      },
                    },
                  }}
                />
              </Col>

              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.actionType`)}
                  label="Action Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Action Type",
                      options: [
                        { label: 'Download', value: DOWNLOAD },
                        { label: 'Co-Brand / Whitelabeling', value: COBRAND },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id].actionType);

                      },
                    },
                  }}
                />
              </Col>

            </>
            }
            {this.state.editFeatures[id]?.type === TYPE_OPTION[2].value &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.actionType`)}
                  label="Action Type"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Action Type",
                      options: [
                        { label: 'Download', value: DOWNLOAD },
                        { label: 'Co-Brand / Whitelabeling', value: COBRAND },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id].actionType);

                      },
                    },
                  }}
                />
              </Col>
            }
            {
              this.state.editFeatures[id]?.type !== TYPE_OPTION[2].value &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.premium`)}
                  label="Premium / Free"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Premium / Free",
                      options: [
                        { label: 'Premium', value: PREMIUM },
                        { label: 'Free', value: NON_PREMIUM },
                      ],
                      multiple: true,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id].premium);

                      },
                    },
                  }}
                />
              </Col>
            }
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, `editFeatures.${id}.limit`)}
                label="Limit"
                required
                validations={[
                  {
                    validate: FormValidator.isNum,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    // type: "",
                    placeholder: "Enter Limit",
                  },
                }}
              />
            </Col>
            {!isTopUp &&
              <Col md={4}>
                <FormElement
                  valueLink={this.linkState(this, `editFeatures.${id}.resetInDays`)}
                  label="Replenishment In"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      placeholder: "Select Replenishment In",
                      options: NumberOfDays?.filter(item => parseInt(this?.state?.resetInDays) >= parseInt(item.value)),
                      multiple: false,
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.editFeatures[id]?.resetInDays);
                        // const result = typeOptions.find(({ value }) => value === this.state.type);
                        // this.setState({ typeLabel: result.label, })


                      },
                    },
                  }}
                />
              </Col>
            }
          </Row>
          {this.state.editFeatures?.length > 1 &&
            <div className="p-4">
              <Image src={closeIcon} className="remove-icon position-static" onClick={() => this.removeEditFeatures(id)} />
            </div>
          }

        </div>

      </>
    );
  };



  onValidSubmit = async () => {
    this.setState({ isLoading: true });
    const data = {
      "data": {
        "premiumPlanUuid": this.state.plan,
        "userUuid": this.props.id,
        "subPremiumPlanUuid": this.state?.offerLine,
        "subPremiumPlanVariationUuid": this.state.billingFrequency,
        ...(this.state.isCustom && {
          "subPremiumPlanVariationSpecification": this?.state?.features?.map((ele) => ({
            "type": ele?.type,
            "contentType": ele?.contentType,
            "actionType": ele?.type === "Personalization" ? ["Cobrand"] : ele?.actionType,
            "contentCategory": ele?.premium,
            "limit": parseInt(ele?.limit),
            "resetInDays": parseInt(ele?.resetInDays),
            "uploadSection": ele?.uploadSection,
            ...(ele?.uuid ? { "uuid": ele.uuid } : {}),
            ...(this.state.isTopUp ? { "isTopup": this.state.isTopUp } : {}),
          }))
        })
      }
    };
    const res = await postAuthCommonApi('user-billing-plan', data)
    // console.log(res)
    if (res.status == 200) {
      this.onHide();
      this.handleClick();
      this.setState({ isLoading: false });

    }
    else {
      this.setState({ isLoading: false });

    }
  }

  onValidEditSubmit = async () => {
    this.setState({ isEditLoading: true });

    const data = {
      "data": {
        "userSubPremiumPlanSpecifications": this?.state?.editFeatures?.map((ele) => {
          return (
            {
              "type": ele?.type,
              "contentType": ele?.contentType,
              "actionType": ele?.type === "Personalization" ? ["Cobrand"] : ele?.actionType,
              "contentCategory": ele?.premium,
              "limit": parseInt(ele?.limit),
              "resetInDays": parseInt(ele?.resetInDays),
              'uploadSection': ele?.uploadSection,
              ...(ele?.uuid ? { 'uuid': ele.uuid } : {}),
              ...(this.state.isTopUp ? { 'isTopup': this.state.isTopUp } : {}),
              ...(this?.state?.editDetails?.userBillings[0]?.uuid ? { 'userBillingUuid': this?.state?.editDetails?.userBillings[0]?.uuid } : {}),
            }
          )
        }
        ) || [],

        ...(this?.state?.editDetails?.user?.uuid ? { 'userUuid': this?.state?.editDetails?.user?.uuid } : {}),
        ...(this?.state?.editDetails?.uuid ? { 'userSubscriptionUuid': this?.state?.editDetails?.uuid } : {}),

      }
    }

    const res = await putAuthCommonApi('user-billing-plan/userSubPremiumPlanSpecification', data)
    // console.log(res)
    if (res && res?.status == 200) {
      this.setState({ editShow: false });
      this.handleClick();
      this.setState({ isEditLoading: false });

    }
    else {
      this.setState({ isEditLoading: false });

    }
  }


  render() {
    const { show, plansData, subPremiumPlan, subPremiumPlanVariation, offerLine, plan, editShow } = this.state;
    const { data, subscriptionLoading } = this.props;

    console.log(this.state, this.props)
    return (
      <div className="activity-tabs-section">
        {/* =============== modal============== */}
        <Modal show={show} onHide={this.onHide} dialogClassName={`custom-modal user-attached-modal `}>
          <Modal.Header>
            <Modal.Title className='red-hat-display-bold f-s-20'>{"Attached Subscription"}</Modal.Title>
            <Image src={closeIcon} className='close-icon model-icon-close' alt='icon' onClick={this.onHide} />
          </Modal.Header>

          <Modal.Body>
            <Form ref={(el) => (this.formRef = el)} onValidSubmit={this.onValidSubmit}>
              <Row>
                <Col sm={6}>
                  {/* {this.state.subCategoryName===""?null: */}
                  <FormElement
                    valueLink={this.linkState(this, "plan")}
                    label="Membership Name"
                    required
                    validations={[
                      {
                        validate: FormValidator.isRequired,
                        message: "Field cannot be empty",
                      },
                    ]}
                    control={{
                      type: SelectControl,
                      settings: {
                        options: plansData?.map((item) => ({ value: item.uuid, label: item.name })),

                        placeholder: "Select Membership Name",
                        multiple: false,
                        searchable: true,
                        onChangeCallback: (onBlur) => {
                          onBlur(this.state.plan);

                          const subPremiumPlan = plansData?.find(ele => ele.uuid === this.state?.plan);
                          const isTopUp = subPremiumPlan?.isTopup
                          this.setState({ subPremiumPlan, isTopUp: isTopUp, offerLine: "", billingFrequency: "" });

                        },
                      },
                    }}
                  />
                  {/* } */}
                </Col>
                {plan &&
                  <Col sm={6}>
                    <FormElement
                      valueLink={this.linkState(this, "offerLine")}
                      label="Plan Name"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Field cannot be empty",
                        },
                      ]}
                      control={{
                        type: SelectControl,
                        settings: {
                          options: subPremiumPlan?.subPremiumPlan?.map((item) => ({ value: item.uuid, label: item.name })),

                          placeholder: "Select Plan Name",
                          multiple: false,
                          searchable: true,
                          onChangeCallback: (onBlur) => {
                            onBlur(this.state.offerLine);
                            const subPremiumPlanVariation = subPremiumPlan?.subPremiumPlan?.find(ele => ele.uuid === this.state?.offerLine);
                            console.log("This is find subPremiumPlanVariation =>", subPremiumPlanVariation);
                            this.setState({ subPremiumPlanVariation, billingFrequency: "" });
                            const customPlans = subPremiumPlan?.subPremiumPlan?.filter(
                              (ele) => ele.isCustom === true
                            );
                            const isCustom = customPlans.some(
                              (customPlan) => customPlan.uuid === this.state?.offerLine
                            );

                            this.setState({ isCustom })

                          },
                        },
                      }}
                    />
                    {/* } */}
                  </Col>
                }
                {
                  offerLine &&
                  <Col sm={6}>
                    <FormElement
                      valueLink={this.linkState(this, "billingFrequency")}
                      label="Variation "
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Field cannot be empty",
                        },
                      ]}
                      control={{
                        type: SelectControl,
                        settings: {
                          options: subPremiumPlanVariation?.subPremiumPlanVariation?.map((item) => ({ value: item.uuid, label: item?.pack !== null ? item?.pack : durationObj[item.resetInDays] })),

                          placeholder: "Select Variation",
                          multiple: false,
                          searchable: true,
                          onChangeCallback: (onBlur) => {
                            onBlur(this.state.billingFrequency);
                          },
                        },
                      }}
                    />
                    {/* } */}
                  </Col>
                }
                <Col md={12}>
                  {this.state.billingFrequency && this.state.isCustom && (
                    <div>
                      <h3 className="inter-semibold f-s-19 lh-24 section-title ">Features / Benefits</h3>
                      {this.state.features?.map((item, i) => this.renderFeature(item, i))}
                      <div className="d-flex justify-content-end">
                        <Button className='primary-btn' onClick={() => this.handleAddFeature()}>+ Add Features</Button>
                      </div>
                    </div>
                  )}
                </Col>

              </Row>
              {/* <div className="submit-wrapper" style={{ justifyContent: "center", alignContent: "flex-end" }}>
                <FormSubmitButton customClass={"primary-btn"}>
                  {this.state.isLoading ? <> <Spinner /> Saving...</> : "Save"}

                </FormSubmitButton>
              </div> */}
              <button type="submit" style={{ display: "none" }} ref={(el) => (this.submitBtn = el)} />

            </Form>

          </Modal.Body>
          <div className="submit-wrapper d-flex justify-content-center align-items-center" style={{ justifyContent: "center" }}>
            <Button disabled={this.state.isLoading} className={"primary-btn"} type="button"
              onClick={() => this.submitBtn.click()}
            >
              {this.state.isLoading ? <> <Spinner /> Saving...</> : "Save"}
            </Button>
          </div>
        </Modal>
        <Modal show={editShow} onHide={this.onEditHide} dialogClassName={`custom-modal user-attached-modal `}>
          <Modal.Header>
            <Modal.Title className='red-hat-display-bold f-s-20'>{"Attached Subscription"}</Modal.Title>
            <Image src={closeIcon} className='close-icon model-icon-close' alt='icon' onClick={this.onEditHide} />
          </Modal.Header>

          <Modal.Body>
            <Form onValidSubmit={this.onValidEditSubmit}>
              <Row>
                <Col md={12}>
                  <div>
                    <h3 className="inter-semibold f-s-19 lh-24 section-title ">Features / Benefits</h3>
                    {this.state.editFeatures?.map((item, i) => this.renderEditFeature(item, i))}
                    <div className="d-flex justify-content-end">
                      <Button className='primary-btn' onClick={() => this.handleAddEditFeature()}>+ Add Features</Button>
                    </div>
                  </div>
                </Col>

              </Row>
              <div className="submit-wrapper" style={{ justifyContent: "center", alignContent: "flex-end" }}>
                <FormSubmitButton customClass={"primary-btn"}>
                  {this.state.isEditLoading ? <> <Spinner /> Saving...</> : "Save"}

                </FormSubmitButton>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        {/* =============== modal end============== */}
        {this.state.resetUsage && (
          <InformationModal
            show={this.state.resetUsage}
            id={this.props.userId}
            title="Are you sure you want to exempt usage for this customer?"
            handleClose={() => this.setState({ resetUsage: false })}
            handleDelete={this.resetUsageHandle}
          />
        )}
        <div className="d-flex align-items-center justify-content-between w-100 py-3">
          <h4 className="inter-semibold f-s-21 lh-32 ">Active Subscription</h4>
          {this.state.userDetails?.user?.role && this.state.userDetails?.user?.role?.roleType == SUPER_ADMIN &&
            <div className="d-flex align-items-center gap-8">
              <Button disabled={!this.props?.userData?.isParent} className="primary-btn" onClick={this.onShow}>Attached Subscription</Button>
              <Button
                disabled={this.state.resetLoading || !this.props?.userId}
                className="secondary-btn"
                onClick={() => this.setState({ resetUsage: true })}
              >
                {this.state.resetLoading ? <> <Spinner /> Exempting...</> : "Exempt Usage"}
              </Button>
            </div>
          }
        </div>
        {subscriptionLoading ?
          <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-12"> <Spinner classes={'black-border'} /> Loading...</div>
          :
          <div className="commom-table-wrapper">
            <CustomTable
              data={data || []}

              columns={[
                {
                  width: 150,
                  title: "Name",
                  dataIndex: "name",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.premiumPlan?.name;
                  },
                },
                {
                  width: 120,
                  title: "Plan Name",
                  dataIndex: "name",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.subPremiumPlan?.name;
                  },
                },
                {
                  width: 80,
                  title: "Variation",
                  dataIndex: "name",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.subPremiumPlanVariation?.pack
                      ? rowData.subPremiumPlanVariation.pack
                      : durationObj[rowData?.subPremiumPlanVariation?.resetInDays];
                  },
                },
                {
                  width: 80,
                  title: "Price",
                  dataIndex: "price",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.amountPaid;
                  },
                },
                {
                  width: 80,
                  title: "Is Paid",
                  dataIndex: "Paid",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.isPaid ? "Yes" : 'No';
                  },
                },
                {
                  width: 100,
                  title: "Coupon Code",
                  dataIndex: "couponCode",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.couponCode ? rowData?.couponCode : 'Not Used';
                  },
                },
                {
                  width: 80,
                  title: "Is Active",
                  dataIndex: "Active",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.isActive ? "Yes" : 'No';
                  },
                },
                {
                  width: 120,
                  title: "Start Date",
                  dataIndex: "startDate",
                  className: "startDate",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return moment(rowData?.startDate).format('lll');
                  },
                },
                {
                  width: 120,
                  title: "End Date",
                  dataIndex: "endDate",
                  className: "endDate",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return moment(rowData?.endDate).format('lll');
                  },
                },
                {
                  width: 90,
                  title: "Action",
                  dataIndex: "",
                  className: "endDate",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return (
                      <div className="d-flex gap-4 justify-content-between">
                        <Button onClick={() => this.setState({ activeHistory: true, subscriptionDetails: rowData })} className="primary-btn" alt=""> View </Button>
                        {rowData?.subPremiumPlan?.isCustom &&
                          <Image
                            src={editIcon}
                            className="edit-icon mx-3"
                            onClick={() => {
                              this.handleEdit(rowData)
                            }}
                          />
                        }

                      </div>
                    )
                  },
                },
                {
                  columnWidth: 120,
                  title: "Status",
                  dataIndex: "isCancelled",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {

                    const status = rowData?.isCancelled ? "Cancelled" : "Active";
                    return status; // Joins statuses if there are multiple
                  },
                }
              ]}
            />
          </div>
        }
        <Modal className="subscription-details-modal" show={this.state.activeHistory} onHide={() => this.setState({ activeHistory: false })}>

          <Modal.Body className="sub-modal-body-modal py-5">
            <Image src={closeIcon} onClick={() => this.setState({ activeHistory: false })} alt="canle icon" className="close-btn pointer" />
            <h4 className="inter-regular black-242 w-100 mb-3 text-start primary">Invoices</h4>
            <table className="w-100 invoice-table-frame">
              <thead>
                <tr className="invoice-header-row">
                  <th className=" inter-regular ">Id</th>
                  {/* <th className=" inter-regular ">Plan</th> */}
                  <th className=" inter-regular ">Date</th>
                  <th className=" inter-regular ">Amount</th>
                  <th className=" inter-regular ">Status</th>
                  <th className=" inter-regular ">Download</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.subscriptionDetails?.userBillings?.map((ele, i) => {
                    return (
                      <tr className="invoice-body-row">
                        <td className=" inter-regular ">{i + 1}</td>
                        {/* <td className=" inter-regular ">{i + 1}</td> */}
                        <td className=" inter-regular ">{moment(ele?.startDate).format('lll')}</td>
                        <td className=" inter-regular ">{ele.amountPaid}</td>
                        <td className=" inter-regular ">{ele.isPaid ? 'Yes' : 'No'}</td>
                        <td className=" inter-regular "><a href={ele?.invoicePdfPath} target="_blank" className=" ponter">Download</a></td>
                      </tr>
                    )
                  })
                }

              </tbody>
            </table>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
function MyEvents({ data }) {

  return (
    <div className="commom-table-wrapper">
      <CustomTable
        data={data || []}
        columns={[
          {
            width: 150,
            title: "Name",
            dataIndex: "name",
            className: "name",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return rowData?.event?.name;
            },
          },
          {
            width: 150,
            title: "Event Format",
            dataIndex: "eventFormat",
            className: "name",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return rowData?.event?.eventFormat;
            },
          },
          {
            width: 150,
            title: "Event Type",
            dataIndex: "eventType",
            className: "name",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return rowData?.event?.eventType;
            },
          },

          {
            width: 170,
            title: "Is Paid",
            dataIndex: "Paid",
            className: "name",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return rowData?.isPaid ? "Yes" : 'No';
            },
          },

          {
            width: 200,
            title: "Start Date",
            dataIndex: "startDate",
            className: "startDate",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return moment(rowData?.event?.startDate).format('lll');
            },
          },
          {
            width: 200,
            title: "End Date",
            dataIndex: "endDate",
            className: "endDate",
            isCell: true,
            render: (text, rowData, dataKey) => {
              return moment(rowData?.event?.endDate).format('lll');
            },
          },


        ]}
      />
    </div>

  )

}